export default {
  formatStringAsFloat(numberString) {
    if (typeof numberString === "number") {
      return numberString;
    } else if (typeof numberString !== "string" || numberString.length === 0) {
      return 0;
    }

    let cleanString = numberString.replaceAll(".", "");

    cleanString = cleanString.replace(",", ".");

    let float = Number.parseFloat(cleanString);

    if (Number.isNaN(float)) {
      return 0;
    }

    return float;
  },

  formatFloatAsGermanNumberString(float) {
    if (float === undefined || float === null) {
      return "";
    }

    return float.toLocaleString("de-DE");
  },

  isFloat(value) {
    if (value === undefined || value === null) {
      return false;
    }

    return Number(value) !== Number.parseInt(value);
  },

  isInteger(value) {
    if (value === undefined || value === null) {
      return false;
    }

    return this.isFloat(value) === false;
  },

  isStringFraction(string) {
    return string.includes("/"); // true
  },

  formatStringFractionAsDecimal(string) {
    let splitted = string.split("/");
    return Number.parseInt(splitted[0], 10) / Number.parseInt(splitted[1], 10);
  },

  round(value, decimals = 0) {
    return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
  },
};
